import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import _ from 'lodash';
import { printSubscribers, setup, track } from 'observable-profiler';
import { Observable } from 'rxjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
   enableProdMode();
}

if (!environment.production) {
   setup(Observable);
}

platformBrowserDynamic([])
   .bootstrapModule(AppModule)
   .then((ref) => {
      if (!_.isNil(navigator.serviceWorker)) {
         navigator.serviceWorker.register('./webagent-worker.js');
      }
      if (!environment.production) {
         track();
         (window as any).stopProfiler = () => {
            ref.destroy();
            const subscribers = track(false);
            printSubscribers({
               subscribers,
            });
         };
      }
   })
   .catch((err) => console.error(err));
